import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, IconButton, Input, TextField, Typography } from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import DataTableItem from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/constants";
import localizationStrings from "../../utils/localizations";
import { MuiFileInput } from "mui-file-input";

// const columns = ;

export default function VideoUpload() {
  const [video, setVideo] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");
  const [originalUrl, setOriginalUrl] = useState();
  const [url, setUrl] = useState();
  const [enteredUrl, setEnteredUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const [, reload] = useState({});
  useEffect(() => {
    if (url) {
      setEnteredUrl("");
    }
    if (enteredUrl) {
      setUrl();
    }
  }, [enteredUrl, url]);

  useEffect(() => {}, []);

  const onSave = async (silent = false) => {
    if (!url && !enteredUrl) {
      alert("Please select a video");
      return;
    }
    if (!silent) setButtonLoading(true);
    try {
      const body = new FormData();
      if (enteredUrl) {
        body.append("videoUrl", enteredUrl);
      } else {
        body.append("video", url);
      }
      const data = await axios.post(baseUrl + "videos", body);
      if (data.data.success) {
        setMessage("");
        setTitle("");
        getVideo(true);
        alert("Video uploaded successfully");
      } else {
        alert(data.data?.message || "Something went wrong!");
      }
      if (!silent) setButtonLoading(false);
    } catch (e) {
      if (!silent) setButtonLoading(false);
      alert(e?.response?.data?.message || e?.message || "Something went wrong");
      console.warn(e);
    }
  };

  const getVideo = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const data = await axios.get(baseUrl + "videos");
      if (data.data.success) {
        console.log(data.data.data?.path);

        setVideo(data.data.data?.path);
        setEnteredUrl(data.data.data?.path);
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      console.warn(e);
    }
  };
  useEffect(() => {
    getVideo();
  }, []);

  return (
    <div style={{ height: "calc(100vh - 56px)", width: "100%", padding: 30 }}>
      {
        <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {video.includes("youtube.com") || video.includes("youtu.be") ? (
            <iframe
              title="YouTube Video"
              style={{ width: "100%", height: 300, borderRadius: 10 }}
              src={"https://www.youtube.com/embed/" + (video.split("v=")[1]?.split("&")[0] || video.split("youtu.be/")[1]?.split("?")[0])}
              allowFullScreen
            ></iframe>
          ) : video.includes("vimeo.com") ? (
            <iframe
              title="Vimeo Video"
              style={{ width: "100%", height: 300, borderRadius: 10 }}
              src={"https://player.vimeo.com/video/" + video.split("vimeo.com/")[1]?.split("?")[0]}
              allowFullScreen
            ></iframe>
          ) : video.includes("dailymotion.com") ? (
            <iframe
              title="Dailymotion Video"
              style={{ width: "100%", height: 300, borderRadius: 10 }}
              src={"https://www.dailymotion.com/embed/video/" + video.split("dailymotion.com/video/")[1]?.split("_")[0]}
              allowFullScreen
            ></iframe>
          ) : video.includes("mp4") || video.includes("webm") || video.includes("ogg") ? (
            <video
              style={{ width: "100%", height: 300, borderRadius: 10 }}
              controls
              src={video}
              onError={(e) => {
                console.log(e);
                setVideo("");
              }}
            />
          ) : (
            <iframe title="Video" style={{ width: "100%", height: 300, borderRadius: 10 }} src={video} allowFullScreen></iframe>
          )}

          <div style={{ height: 20 }} />
          <MuiFileInput label={"Video"} variant="filled" value={!url ? (originalUrl ? new File([], originalUrl) : null) : url} onChange={setUrl} />

          <div style={{ height: 20 }} />
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            OR
          </Typography>
          <div style={{ height: 20 }} />
          <TextField
            label={"Video URL"}
            variant="filled"
            value={enteredUrl}
            onChange={(e) => {
              setEnteredUrl(e.target.value);
            }}
            fullWidth
          />
          <div style={{ height: 20 }} />

          {buttonLoading ? (
            <div className="loader"></div>
          ) : (
            <Button onClick={() => onSave()} variant="contained">
              {localizationStrings.Send}
            </Button>
          )}
        </Box>
      }
    </div>
  );
}
